import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { FaqIndexComponent } from './crud-index/crud-index.component';
import { FaqCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: FaqIndexComponent,
  },
  {
    path: 'new',
    component: FaqCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: FaqCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: FaqCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FaqRoutingModule {}
